export type PluralCategory = 'zero' | 'one' | 'two' | 'few' | 'many' | 'other';
export type MessageTemplate = string | (Partial<Record<PluralCategory, string>> & { other: string });
export type MessageParameters = Readonly<Record<string, string | number>>;

export const SUPPORTED_LOCALES = ['en', 'zh-Hans', 'ru', 'es'] as const;
export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

export const LOCALIZATION_VERSION = '1.0.0';
